import { BeakerIcon, BuildingOffice2Icon, SparklesIcon, UsersIcon } from '@heroicons/react/20/solid'
import type React from 'react'
import { useLocation } from 'react-router-dom'
import { Navbar, NavbarItem, NavbarSection, NavbarSpacer } from '../catalyst/navbar'
import { Sidebar, SidebarBody, SidebarFooter, SidebarHeader, SidebarHeading, SidebarItem, SidebarLabel, SidebarSection, SidebarSpacer } from '../catalyst/sidebar'
import { SidebarLayout } from '../catalyst/sidebar-layout'
import { AccountMenu } from './account-menu'

const brandClass = 'font-serif text-lg italic tracking-tight'
const iconClass = 'size-4 shrink-0 text-zinc-500 dark:text-zinc-400'

const NAV = [
  {
    heading: 'Catalogues',
    items: [
      { href: '/pesticides', label: 'Pesticides', icon: BeakerIcon },
      { href: '/fertilizers', label: 'Fertilizers', icon: SparklesIcon },
    ],
  },
  {
    heading: 'Customers',
    items: [
      { href: '/organizations', label: 'Organizations', icon: BuildingOffice2Icon },
      { href: '/users', label: 'Users', icon: UsersIcon },
    ],
  },
]

export function Shell({ children, flush }: React.PropsWithChildren<{ flush?: boolean }>) {
  const { pathname } = useLocation()

  const sidebarContent = (
    <Sidebar>
      <SidebarHeader>
        <span className={`flex items-center gap-2 px-2 py-2 text-zinc-950 dark:text-white ${brandClass}`}>
          Farmula <span className="font-sans text-xs font-medium not-italic tracking-normal text-zinc-500 dark:text-zinc-400">Admin</span>
        </span>
      </SidebarHeader>

      <SidebarBody>
        {NAV.map((group) => (
          <SidebarSection key={group.heading}>
            <SidebarHeading>{group.heading}</SidebarHeading>
            {group.items.map(({ href, label, icon: Icon }) => (
              <SidebarItem key={href} href={href} current={pathname.startsWith(href)}>
                <Icon className={iconClass} />
                <SidebarLabel>{label}</SidebarLabel>
              </SidebarItem>
            ))}
          </SidebarSection>
        ))}
        <SidebarSpacer />
      </SidebarBody>

      <SidebarFooter className="max-lg:hidden">
        <AccountMenu variant="sidebar" />
      </SidebarFooter>
    </Sidebar>
  )

  const mobileNavbar = (
    <Navbar>
      <NavbarItem href="/" className={brandClass}>
        Farmula Admin
      </NavbarItem>
      <NavbarSpacer />
      <NavbarSection>
        <AccountMenu variant="navbar" />
      </NavbarSection>
    </Navbar>
  )

  return (
    <SidebarLayout navbar={mobileNavbar} sidebar={sidebarContent} flush={flush}>
      {children}
    </SidebarLayout>
  )
}
